import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { loaderState } from '../../store/Atoms';
import { transWgsTo5186 } from '../../ol/projection';
import { flushSync } from 'react-dom';

const UseTileMapUpload = ({ mapInstance, isObjectReady }) => {
  const [loaderData, setLoaderData] = useRecoilState(loaderState);

  const [tileMap, setTileMap] = useState<any>(null); // 정사영상 (폴더>이미지) 파일 저장소
  const [tileCenter, setTileCenter] = useState<any>({ lat: 0, lon: 0 });
  // tileCenter -> 지도 위치 변경
  useEffect(() => {
    if (isObjectReady) {
      // const coord = [166773.13066937256, 293138.6459483637];

      // const transCoord2 = transform([tileCenter?.lon, tileCenter?.lat], 'EPSG:4326', 'EPSG:5186');
      const transCoord = transWgsTo5186([tileCenter?.lon, tileCenter?.lat]);
      console.log(transCoord);

      setTimeout(() => {
        if (tileCenter?.lat !== 0) {
          mapInstance?.moveToCoord(transCoord); // 좌표이동
          mapInstance?.getMapInstance()?.getView()?.setZoom(16); // 줌레벨 16 변경
        }
      }, 100);
    }
  }, [isObjectReady, mapInstance, tileCenter]);

  // 정사영상 초기화 버튼 이벤트
  const resetTileLayer = () => {
    setTileMap(null);
    mapInstance?.removeLocalTileLayer();
  };

  // 정사영상 레이어 토글
  const toggleTileLayer = (bool) => {
    // mapInstance?.getTileLayerVisible();
    mapInstance?.localTileLayerToggle(bool);
  };

  // 타일의 중심 좌표를 계산하는 함수 (줌 레벨과 타일의 X, Y 좌표 기반)
  const calculateCenterCoordinates = (zoom, x, y) => {
    const n = Math.pow(2, zoom);
    const lon_deg = (x / n) * 360.0 - 180.0;
    const lat_rad = Math.atan(Math.sinh(Math.PI * (1 - (2 * y) / n)));
    const lat_deg = lat_rad * (180.0 / Math.PI);
    return { lat: lat_deg, lon: lon_deg, zoom }; // lat, lon, zoom
  };

  // (전체 타일 X ->) 마지막 maxZoom 타일의 중심 좌표를 계산하는 함수
  const calculateOverallCenter = (tileData, maxZoom) => {
    if (tileData.length === 0) return null;

    // 구면 좌표계로 변환하여 X, Y, Z 좌표 계산
    let X = 0,
      Y = 0,
      Z = 0;
    let length = 0;

    console.time('OverallCenterCalculating');
    tileData.forEach((tile) => {
      // maxZoom 레벨인 타일들만 계산
      if (tile.zoom === maxZoom) {
        const lat = (tile.coordinates.lat * Math.PI) / 180; // 위도를 라디안으로 변환
        const lon = (tile.coordinates.lon * Math.PI) / 180; // 경도를 라디안으로 변환

        X += Math.cos(lat) * Math.cos(lon);
        Y += Math.cos(lat) * Math.sin(lon);
        Z += Math.sin(lat);

        length += 1;
      }
    });
    console.timeEnd('OverallCenterCalculating');

    // 타일의 개수로 나눠 평균을 구함
    //  const totalTiles = tileData.length;
    const totalTiles = length;
    X = X / totalTiles;
    Y = Y / totalTiles;
    Z = Z / totalTiles;

    // 평균 구면 좌표를 다시 위도와 경도로 변환
    const lon = (Math.atan2(Y, X) * 180) / Math.PI; // 경도
    const hyp = Math.sqrt(X * X + Y * Y); // X, Y의 크기
    const lat = (Math.atan2(Z, hyp) * 180) / Math.PI; // 위도

    return { lat, lon };
  };

  console.log(loaderData);
  const onChangeLocalTileLayer = async (event) => {
    const { files } = event.target;
    const filePromises: any[] = [];
    // 로딩바를 즉시 보여주기 위해 flushSync 사용
    flushSync(() => {
      setLoaderData({ show: true });
    });
    console.log('loader start');
    console.time('fileLoading');

    setTimeout(async () => {
      // 비동기 파일 읽기 작업을 병렬로 처리
      Array.from(files).map((file: any) => {
        const { type, name, webkitRelativePath } = file;

        // 이미지 파일 및 조건 필터링
        if (type.includes('image') && !name.includes('._')) {
          const pathComponents = webkitRelativePath.split('/');

          if (!pathComponents[2]?.includes('._') && !pathComponents[3]?.includes('._') && pathComponents.length > 3) {
            const zoom = pathComponents[1];
            const x = pathComponents[2];
            const y = pathComponents[3]?.split('.')[0];
            // console.log(zoom);

            const reader = new FileReader();
            const filePromise = new Promise((resolve, reject) => {
              reader.onload = (e: any) => {
                resolve({
                  zoom,
                  x,
                  y,
                  src: e.target.result, // Base64 인코딩된 이미지
                  coordinates: calculateCenterCoordinates(zoom, x, y), // 타일 중심 좌표 계산
                });
              };
              reader.onerror = reject;
              reader.readAsDataURL(file); // 파일을 Base64로 읽기
            });
            filePromises.push(filePromise); // promise 배열 만들기
          }
        }
      });

      // 파일들이 모두 읽히면 상태에 저장
      const tiles = await Promise.all(filePromises);

      let maxZoom = 0;
      const tileMap = {};
      tiles.forEach((tile) => {
        if (!tileMap[tile.zoom]) tileMap[tile.zoom] = {};
        if (!tileMap[tile.zoom][tile.x]) tileMap[tile.zoom][tile.x] = {};
        tileMap[tile.zoom][tile.x][tile.y] = tile.src; // 피라미드 구조 데이터 만들기

        // 가장 큰 zoom 레벨 저장
        if (Number(tile.zoom) > maxZoom) {
          maxZoom = tile.zoom;
        }
      });

      setTileMap(tileMap); // 타일맵 이미지 데이터 저장
      mapInstance?.initializeMap(tileMap); // 지도에 타일맵 레이어 추가

      // 여러 타일의 중심 좌표 계산 및 저장
      const overallCenter = calculateOverallCenter(tiles, maxZoom);
      setTileCenter(overallCenter); // 타일들의 중심 좌표 저장

      // 파일 로딩 완료 후 로딩바 제거
      setLoaderData({ show: false });
      console.log('loader end');
      console.timeEnd('fileLoading');

      event.target.value = null; // input 초기화
    }, 200);
  };
  return { onChangeLocalTileLayer, toggleTileLayer, resetTileLayer, tileMap };
};

export default UseTileMapUpload;
